import React from 'react'
import { HelpCenterCardButtonProps } from './_props'
import HelpCenterCardButtonClickable from './HelpCenterCardButtonClickable'
import HelpCenterCardSupportButton from './HelpCenterCardSupportButton'

const HelpCenterCardButton: React.FC<HelpCenterCardButtonProps> = ({
    buttonName,
    handleClick,
    colorVariant = 'primary',
}) => {
    if (buttonName) {
        return (
            <HelpCenterCardButtonClickable
                buttonName={buttonName}
                handleClick={handleClick}
                colorVariant={colorVariant}
            />
        )
    }

    return <HelpCenterCardSupportButton />
}

export default HelpCenterCardButton
